<template>
  <router-link :to="{ name: 'Branch', params: { name: string_to_slug(city.name), id:city.id, title:city.name }}" class="city-card" @click.native="onSelect()">
    <img :src="'http://image.tmdb.org/t/p/w185/' + city.poster_path" alt="" class="city-card__cover">
    <div class="city-card__overlay">
      <div class="city-card__title">{{ city.name }}</div>
      <div class="city-card__subtitle">See full serie</div>
      <div class="city-card__number">{{ city.dorms_count }}</div>
    </div>
    <div class="city-card__cnt">
      <v-link
        class="city-card__button"
        :to="{ name: 'City', params: { city: city.slug }}"
        title="Inspect Serie"
      />
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'SerieCard',
  props: {
    city: Object
  },
  methods: {
        string_to_slug (str) {
        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()
  
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        var to   = "aaaaeeeeiiiioooouuuunc------"
        for (var i=0, l=from.length ; i < l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes

        return str
    },    
    onSelect() {
      window.localStorage.setItem('district_name', '')
      window.localStorage.setItem('description', this.city.overview)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/city-card";
</style>
